<div class="diagnostics-page">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <h1 class="page-title">Checkprint Diagnostics</h1>
      <p class="page-subtitle">
        Diagnose request issues and monitor system health
      </p>
    </div>
  </div>

  <!-- Tab Bar -->
  <div class="tab-bar">
    <button
      class="tab-button"
      [class.active]="activeTab === 'request'"
      (click)="setTab('request')">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      Request Diagnostic
    </button>
    <button
      class="tab-button"
      [class.active]="activeTab === 'health'"
      (click)="setTab('health')">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
      </svg>
      System Health
    </button>
    <button
      class="tab-button"
      [class.active]="activeTab === 'file-storage'"
      (click)="setTab('file-storage')">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <path
          d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
      </svg>
      File Storage
    </button>
  </div>

  <div class="tab-content">
    @if (activeTab === 'request') {
      <div class="tab-panel">
        <app-diagnostic-request-tab />
      </div>
    }
    @if (activeTab === 'health') {
      <div class="tab-panel">
        <app-diagnostic-system-health-tab />
      </div>
    }
    @if (activeTab === 'file-storage') {
      <div class="tab-panel">
        <app-diagnostic-file-storage-tab />
      </div>
    }
  </div>
</div>
